document.addEventListener("DOMContentLoaded", function() {
  const hcCalcTrigger = document.querySelector('.hc-calculator');
  const hcCalculatorContent = document.querySelector('.hc-calculator-content');
  const hcWidthAll = document.querySelectorAll('.hc-width-input');
  const hcHeigthAll = document.querySelectorAll('.hc-height-input');
  const hcSizesM = document.querySelector('.hc-sizes-m');

  if(hcCalcTrigger){
    hcCalcTrigger.addEventListener('click', function() {
      hcCalculatorContent.classList.toggle('hc-shown');
    });
  }

  const hcInputs = document.querySelectorAll('.hc-calc-input');
  hcInputs.forEach(function(hc_input) {
    hc_input.addEventListener('change', dispatchInputChange);
    hc_input.addEventListener('keyup', dispatchInputChange);
  });

  function dispatchInputChange() {
    const inputChange = new Event("inputChange");
    document.dispatchEvent(inputChange);
  }

  document.addEventListener("inputChange", function() {
    let hcWidth = 0;
    let hcHeigth = 0;
    const hcWidthRoll = parseInt(hcSizesM.getAttribute('data-size-w'));
    const hcHeigthRoll = parseInt(hcSizesM.getAttribute('data-size-h'));
    const hcRollsText = hcSizesM.getAttribute('data-rolls');
    const hcTemplate = hcSizesM.getAttribute('data-template');
    const hcType = hcCalculatorContent.getAttribute('data-type');
    const hcMatch = hcCalculatorContent.getAttribute('data-match');
    const hcLimit = hcCalculatorContent.getAttribute('data-walls-limit');

    const hcDiv1 = 0.53;
    let hcDiv2 = 4;
    let hcRollsTotal = 0;

    hcWidthAll.forEach(widthInput => {
      if (widthInput.value !== '') {
        const value = parseInt(widthInput.value);
        hcWidth += widthInput.getAttribute('data-type') === 'm' ? value * 100 : value;
      }
    });

    if (hcTemplate === 'Килим') {
      hcHeigth = 1;
    } else {
      hcHeigthAll.forEach(heightInput => {
        if (heightInput.value !== '') {
          const value = parseInt(heightInput.value);
          hcHeigth += heightInput.getAttribute('data-type') === 'm' ? value * 100 : value;
        }
      });
    }

    const hcSizeTotal = hcWidth * hcHeigth;
    const hcSizeRoll = hcWidthRoll * hcHeigthRoll;

    if (hcTemplate === 'Килим') {
      const result = Math.ceil(hcSizeTotal / hcSizeRoll);
      
      document.querySelector('.hc-sizes-result').innerHTML = `${result} ${hcRollsText}`;
      document.querySelector('.hc-quantity-wrapper .js-qty__num').value = result;
    } else {
      if (hcType === 'Тапет') {
        if (hcMatch === 'Без напасване') {
          hcDiv2 = (hcHeigth <= 250) ? 4 : 3;
          hcRollsTotal = Math.ceil(hcWidth / 100 / hcDiv1 / hcDiv2);
        } else {
          if (hcHeigth <= 310) {
            hcDiv2 = 3;
            hcRollsTotal = Math.ceil(hcWidth / 100 / hcDiv1 / hcDiv2);
          } else {
            document.querySelector('.hc-sizes-result').innerHTML = hcLimit;
            return;
          }
        }
        document.querySelector('.hc-sizes-result').innerHTML = `${hcRollsTotal} ${hcRollsText}`;
        document.querySelector('.hc-quantity-wrapper .js-qty__num').value = hcRollsTotal;
        document.querySelector('.hc-quantity-wrapper .js-qty__num').setAttribute("value", hcRollsTotal);
      } else {
        const result = Math.ceil(hcSizeTotal / hcSizeRoll);
        document.querySelector('.hc-sizes-result').innerHTML = `${hcWidth / 100} x ${hcHeigth / 100} = ${result} ${hcRollsText}`;
        document.querySelector('.hc-quantity-wrapper .js-qty__num').value = result;
        document.querySelector('.hc-quantity-wrapper .js-qty__num').setAttribute("value", result);
      }
    }

    document.querySelector('.hc-quantity-wrapper .js-qty__num').dispatchEvent(new Event('change'));
  });
  const hcRange = document.querySelector("#hc-range");
    hcRange.addEventListener("input", (event) => {
    var hcValue = event.target.value;
      
    document.querySelector('.hc-quantity-wrapper .js-qty__num').value = hcValue / 5;
    document.querySelector('.hc-quantity-wrapper .js-qty__num').setAttribute("value", hcValue);
    document.querySelector('.hc-slider-text').innerText = hcValue;
  });
});

(function(){
  function hcMoveCustomWrapperIntoFirstTab(){
    const source = document.querySelector('.hc-custom-wrapper');
    if(!source) return;

    const firstTab = document.querySelector('.product-block.product-block--tab');
    if(!firstTab) return;

    if(firstTab.dataset.hcCustomMoved === '1') return;

    const dest = firstTab.querySelector('.collapsible-content__inner') || firstTab;

    while(source.firstChild){
      dest.appendChild(source.firstChild);
    }

    source.remove();
    firstTab.dataset.hcCustomMoved = '1';
  }

  document.addEventListener('DOMContentLoaded', hcMoveCustomWrapperIntoFirstTab);
  document.addEventListener('shopify:section:load', hcMoveCustomWrapperIntoFirstTab);
  document.addEventListener('shopify:section:reorder', hcMoveCustomWrapperIntoFirstTab);
})();

(function(){
  document.addEventListener('click', function(e){
    const btn = e.target.closest('.hc-upsell-trigger');
    if(!btn || btn.disabled) return;
    e.preventDefault();

    const variantId = btn.getAttribute('data-variant');
    if(!variantId) return;

    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({items: [{id: Number(variantId), quantity: 1}]})
    })
      .then(function(res){
        if(!res.ok) throw new Error('add to cart failed');
        return res.json();
      })
      .then(function(){
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:open'));
      })
      .catch(function(err){ console.error(err); })
      .finally(function(){ btn.disabled = false; });
  });
})();
